<template>
  <v-card class="overview mt-3 main" color="primary" dark>
    <v-card-text>
      <v-row justify="center">
        <v-col v-if="!isSDECC" md="3" cols="6" class="analytics">
          <span class="figure">{{ dashboard.teachers_count }}</span>
          <p class="label">Registered Users</p>
        </v-col>
        <v-col v-if="!isSDECC" md="3" cols="6" class="analytics">
          <span class="figure">{{ dashboard.custom_classes_count }}</span>
          <p class="label">Active Classes</p>
        </v-col>
        <v-col v-if="!isSDECC" md="3" cols="6" class="analytics">
          <span class="figure">{{ dashboard.students_count }}</span>
          <p class="label">Active Students</p>
        </v-col>
        <v-col v-else md="3" cols="6" class="analytics">
          <span class="figure">{{ dashboard.students_count }}</span>
          <p class="label">Registered Users</p>
        </v-col>
        <v-col md="3" cols="6" class="analytics">
          <span class="figure">{{ dashboard.completed_lessons_count }}</span>
          <p class="label">Completed {{ lessonTerm | capitalize }}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ReportOverview',
  data() {
    return {
      dashboard: {
        teachers_count: 0,
        custom_classes_count: 0,
        students_count: 0,
        completed_lessons_count: 0
      },
      isSDECC: false
    }
  },
  async created() {
    this.dashboard = await this.$axios.get(
      'api/clients/reports?type=dashboard&date_start=2010-01-01&date_end=2030-01-01'
    )
  },
  mounted() {
    if (this.$store.state.isSDECC == 1) {
      this.isSDECC = true
    }
  },
  computed: {
    ...mapState(['lessonTerm'])
  }
}
</script>

<style lang="scss" scoped>
.overview {
  &.main {
    display: block;
    width: 100%;

    h2 {
      font-size: 55px;
      line-height: 55px;
      padding: 0;
      margin: 0;
      font-weight: normal;
    }

    h3 {
      font-size: 30px;
      font-weight: normal;
    }

    .analytics {
      text-align: center;

      .figure {
        font-size: 60px;
        padding: 0;
        max-width: 0;
        line-height: 140px;

        &.students {
          font-size: 100px;
        }
      }
      .label {
        padding: 0;
        font-size: 16px;
      }
    }
  }
}
</style>
